import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'

export const isRichTextEmpty = data =>
  isEmpty(data) || filter(data, item => !!item.text).length === 0



// WEBPACK FOOTER //
// ./lib/richText/index.js